import { PREFIX } from '@/api/urls.js';

const pubParams = {
  isShow: false, //是否开通
  isLoading: true, //加载状态
  isFirstAct: false, //是否触发过
  pageIsAdd: false, //当前页数是否 +1
  pageScrollHeight: 0, //滚轮所在的位置
  recordScrollHeight: 0, //记录滚轮所在的位置
  hasMore: 0, //是否更多还有更多数据，由接口返回
  allData: [
    { title: '当前行程', data: [], isMust: true, type: 'current' },
    { title: '历史行程', data: [], isMust: true, type: 'history' },
  ],
  type: 'get',
  delType: 'post',
  delParams: ['order_id'],
}

const trainParams = {
  type: 'post',
  name: '火车票',
  keyTitle: 'train',
  component: 'train-card',
  delUrl: `/${PREFIX}/train-toc/delOrder`,
  url: `/${PREFIX}/train-toc/order/getListV2`,
  params: ['company_id', 'member_id', 'page_size^false', 'last_order_id^false'],
  state: {
    page_size: 10,
    last_order_id: 0
  },
  allData: [
    { title: '当前行程', data: [], isMust: false, type: 'current' },
    { title: '历史行程', data: [], isMust: false, type: 'history' }
  ]
};

export default { ...pubParams, ...trainParams }
